export enum BusinessLineEnum {
  Global = 1,
  Clinic = 2,
  Hospital = 3,
}

export enum BusinessLineName {
  Global = 'Global',
  Clinic = 'Clinic',
  Hospital = 'Hospital',
}
